import React from 'react';
import productMockup from '@/assets/product-mockup.png';

const HomeProductMockup = () => {
  return (
    <section id="how-it-works" className="py-24 px-6 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ letterSpacing: '-0.03em' }}>
            See the full picture
          </h2>
          <p className="text-xl text-gray-600">
            Cognitive + behavioral assessments with AI-powered personality analysis.
          </p>
        </div>

        <div className="relative animate-fade-in">
          <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-96 h-96 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full blur-3xl opacity-30" />
          
          <div className="relative bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden">
            <img 
              src={productMockup} 
              alt="WiseVAs candidate management interface showing assessment results"
              className="w-full h-auto"
            />
          </div>
        </div>

        <p className="text-center text-gray-600 mt-12 text-lg">
          Scientifically-validated assessments with{' '}
          <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent font-medium">
            AI-powered insights
          </span>{' '}
          in 10 minutes
        </p>
      </div>
    </section>
  );
};

export default HomeProductMockup;
